import { getLogger } from '@cian/logger/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getConfig } from '@cian/config/browser';

import { IFrameManager } from './IFrameManager';
import { EPushWorkerUrls } from '../../shared/constants/routeNames';
import { initDependencies, setupDependencies } from '../common/dependencies';

setupDependencies();
initDependencies();

window.addEventListener('DOMContentLoaded', async () => {
  const logger = getLogger();
  const httpApi = getHttpApi();
  const config = getConfig();

  const manager = new IFrameManager({
    workerSrc: EPushWorkerUrls.workerScript,
    dependencies: {
      logger,
      httpApi,
      config,
    },
  });

  try {
    await manager.register();
  } catch (error) {
    logger.error(`Push Worker registration error ${error}`);

    return;
  }

  try {
    await manager.ensureSubscription();
  } catch (error) {
    logger.error(`Push Worker failed to register endpoint ${error}`);
  }
});
